// Human-readable labels for technical attribute values
export const ATTRIBUTE_VALUE_LABELS: Record<string, Record<string, string>> = {
  material: {
    premium_matte_paper: 'Papier mat premium',
    canvas: 'Toile',
    paper: 'Papier',
  },
  finish: {
    matte: 'Mat',
    glossy: 'Brillant',
    satin: 'Satiné',
  },
  frameOption: {
    none: 'Sans cadre',
    wood: 'Cadre bois',
    metal: 'Cadre métal',
  },
  frameColor: {
    black: 'Noir',
    white: 'Blanc',
    natural: 'Naturel',
    dark: 'Foncé',
  },
  qualityTier: {
    standard: 'Standard',
    premium: 'Premium',
    luxury: 'Luxe',
  },
};

export const ATTRIBUTE_KEY_LABELS: Record<string, string> = {
  size: 'Taille',
  material: 'Matériau',
  finish: 'Finition',
  frameOption: 'Encadrement',
  frameColor: 'Couleur cadre',
  qualityTier: 'Qualité',
};

const ORIENTATION_LABELS: Record<string, string> = {
  portrait: 'Portrait',
  landscape: 'Paysage',
  square: 'Carré',
};

/**
 * Format a format_size string to human-readable French.
 * "portrait_30x40" → "Portrait 30×40 cm"
 * "square_40x40" → "Carré 40×40 cm"
 * "30x40" → "30×40 cm" (legacy)
 */
export function formatSizeDisplay(formatSize: string): string {
  const match = formatSize.match(/^(portrait|landscape|square)_(\d+x\d+)$/);
  if (match) {
    const orientationLabel = ORIENTATION_LABELS[match[1]] || match[1];
    const dimensions = match[2].replace('x', '×');
    return `${orientationLabel} ${dimensions} cm`;
  }
  // Legacy format
  return formatSize.replace('x', '×') + ' cm';
}

/**
 * Get human-readable display string for an attribute key/value pair.
 * Returns null if the key is unknown or value is empty.
 */
export function getAttributeDisplay(key: string, value: string): string | null {
  if (key === 'frameColor' && !value) return null;

  const keyLabel = ATTRIBUTE_KEY_LABELS[key];
  if (!keyLabel) return null;

  if (key === 'size') {
    const formatted = value.replace('x', '×');
    return `${keyLabel}: ${formatted} cm`;
  }

  const valueLabel = ATTRIBUTE_VALUE_LABELS[key]?.[value] || value;
  return `${keyLabel}: ${valueLabel}`;
}

/**
 * Get human-readable label for a single attribute value.
 * Falls back to the raw value if no mapping exists.
 */
export function getValueLabel(category: string, value: string): string {
  return ATTRIBUTE_VALUE_LABELS[category]?.[value] || value;
}
